import { useCompanyApi } from '@/api/client/api-client';
import { notifyError } from '@/bugsnag';
import type { UserWithBranch } from '@/components/Views/Company/File/file.types';
import { defineStore } from 'pinia';
import { computed } from 'vue';

export const useFileNotificationStore = defineStore('fileNotification', () => {
    const companyFetch = useCompanyApi();

    const getNotifiableUsers = () => {
        const { data, error, isFetching, onFetchError } = companyFetch('/file_notification/get_users').json<UserWithBranch[]>();

        onFetchError(ctx => {
            notifyError(ctx.error, 'fileNotification:getUsers', { data: ctx.data });
        });
        return {
            users: computed(() => data.value ?? []),
            error,
            isFetching,
        };
    };

    return {
        getNotifiableUsers,
    };
});
